import React from "react";

const ExternalLink: React.FunctionComponent<any> = ({ children, ...props }) => {
  return <a {...props} rel="noopener noreferrer" target="_blank">{children}</a>
};
export default ExternalLink;
